import { render, staticRenderFns } from "./FactFindPage.vue?vue&type=template&id=1dabeff9&scoped=true&"
import script from "./FactFindPage.vue?vue&type=script&lang=js&"
export * from "./FactFindPage.vue?vue&type=script&lang=js&"
import style0 from "./FactFindPage.vue?vue&type=style&index=0&id=1dabeff9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dabeff9",
  null
  
)

export default component.exports